var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear forma de pago","back-to":"/formasPago"}}),_c('formulario-forma-pago',{attrs:{"forma-pago":_vm.formaPago},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }